import PropTypes from 'prop-types'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
}

export default propTypes
